import {WalkthroughId} from './types';

const storageKey = (id: WalkthroughId, version: number) => `walkthrough:${id}:v${version}`;

export const hasSeenWalkthrough = (id: WalkthroughId, version: number): boolean => {
  try {
    return window.localStorage.getItem(storageKey(id, version)) === '1';
  } catch {
    return false;
  }
};

export const markWalkthroughSeen = (id: WalkthroughId, version: number): void => {
  try {
    window.localStorage.setItem(storageKey(id, version), '1');
  } catch {
    /* noop */
  }
};

export const clearWalkthroughSeen = (id: WalkthroughId, version: number): void => {
  try {
    window.localStorage.removeItem(storageKey(id, version));
  } catch {
    /* noop */
  }
};
